export default __webpack_public_path__ + "static/media/profilepic.4676cf15.png";